import {DEFAULT_LOCALE, DEFAULT_TIMEZONE} from "./config";
import {toDate} from "./core";

function formatter(options) {
    return new Intl.DateTimeFormat(DEFAULT_LOCALE, {
        timeZone: DEFAULT_TIMEZONE,
        ...options,
    });
}

export function formatISO(date) {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: DEFAULT_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(toDate(date));
}

export function formatDMY(date) {
    return formatter({
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(toDate(date));
}

export function formatDMYDash(date) {
    return new Intl.DateTimeFormat(DEFAULT_LOCALE, {
        timeZone: DEFAULT_TIMEZONE,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(toDate(date));
}

export function formatLong(date) {
    return formatter({
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(toDate(date));
}

export function formatDayMonth(date) {
    return formatter({
        day: 'numeric',
        month: 'long',
    }).format(toDate(date));
}
